/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */

export type ProgramStatus = (typeof ProgramStatus)[keyof typeof ProgramStatus];

export const ProgramStatus = {
  pending_user_approval: "pending_user_approval",
  pending_clinic_approval: "pending_clinic_approval",
  enrolled: "enrolled",
  unenrolled: "unenrolled",
  ineligible: "ineligible",
  complete: "complete",
  lapsed: "lapsed",
} as const;
